const Footer = () => {
  return <div className="fixed bottom-0 "> </div>
}

export default Footer